import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import clsx from 'clsx';

export interface DialogOptions {
  transition?: boolean;
  className?: string;
}

interface DialogProps {
  children: JSX.Element;
  isOpen: boolean;
  options?: DialogOptions;
  onClose?: () => void;
}

export const CallaboDialog = ({ children, options, isOpen, onClose }: DialogProps): JSX.Element => {
  const handleClose = () => {
    onClose?.();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} className={'group/dialog relative z-[100]'}>
      <div
        className={clsx('fixed inset-0 flex w-screen items-center justify-center')}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <DialogBackdrop
          transition={options?.transition ?? true}
          className={clsx(
            'fixed inset-0 bg-black/30 duration-100 ease-in-out data-[closed]:bg-opacity-0 z-[99]'
          )}
        />
        <DialogPanel
          transition={options?.transition ?? true}
          className={clsx(
            'bg-white shadow rounded-lg py-7 px-6 mx-3 duration-200 ease-in-out data-[closed]:opacity-0 max-h-[100vh] overflow-auto z-[100]',
            options?.className
          )}
        >
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  );
};
